<template>
  <div class="add-item">
    <div class="row" onclick="">
      <vue-autosuggest :suggestions="[{data: filteredCategoriesNames}]"
                       :input-props="{id:'category', placeholder:'קטגוריה'}"
                       v-model="category"
                       @selected="onSelected"
                       component-attr-class-autosuggest-results="suggestions-container"
      />
      <count-buttons v-model="count"/>
    </div>
    <div class="add">
      <button class="main" @click="addItem" :disabled="!name || !category">הוספה</button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import { VueAutosuggest } from 'vue-autosuggest'
  import CountButtons from '@/components/CountButtons'

  export default {
    name: "AddItem",
    components: {CountButtons, VueAutosuggest},
    data () {
      return {
        count: 0,
        category: ''
      }
    },
    computed: {
      ...mapState(['authUser', 'currentQuery', 'list', 'categories']),
      ...mapGetters(['dbListRef', 'dbCategoriesRef', 'maxItemIndex']),
      name: {
        get () {
          return this.currentQuery
        },
        set (val) {
          this.setCurrentQuery('')
        }
      },
      filteredCategories () {
        return !this.category ? this.categories : this.categories.filter(i => i.name.toLowerCase().indexOf(this.category.toLowerCase()) > -1)
      },
      filteredCategoriesNames () { return this.filteredCategories.map(c => c.name) }
    },
    methods: {
      ...mapActions(['setCurrentQuery', 'createCategoryIfDoesntExist']),
      onSelected (item) {
        this.category = item.item
      },
      addItem () {
        if (!this.name || !this.category) {
          console.log('cant save')
          return
        }

        if (this.list.filter(i => i.name === this.name).length) {
          // todo override existing details
          return
        }

        this.createCategoryIfDoesntExist(this.category)
          .then(categoryID => {
            this.dbListRef
              .add({
                name: this.name,
                count: this.count,
                categoryID: categoryID,
                categoryRef: this.dbCategoriesRef.doc(categoryID),
                checked: false,
                index: (this.maxItemIndex || 0) + 1
              })

            this.name = ''
            this.count = 1
            this.category = null
          })

        this.$root.$emit('itemAdded')
      }
    },
    mounted () {

    }
  }
</script>

<style scoped lang="sass">
  .add-item
    // height: 100vh
    // width: calc(100% - #{$size-12 * 2})
    background-color: $white
    // position: fixed
    // z-index: 8

    +dark
      background-color: $black

    .row
      align-items: flex-start

  .add
    margin-top: $size-12
</style>
